import { GlyphName } from '@neptune/shared/core-glyphs-domain';

import { AttributeDefinition } from 'domain/experiment/attribute';

import { DynamicAttributeDefinition, DynamicAttributeTypes } from './types';

export type SupportedDynamicAttributesRecord = Record<DynamicAttributeTypes, { icon: GlyphName }>;

const SUPPORTED_DYNAMIC_ATTRIBUTE_TYPES_DEFS: SupportedDynamicAttributesRecord = {
  fileSeries: { icon: 'file-series' },
  floatSeries: { icon: 'chart-line' },
  histogramSeries: { icon: 'histogram' },
  stringSeries: { icon: 'list' },
};

export const SUPPORTED_DYNAMIC_ATTRIBUTE_TYPES: DynamicAttributeTypes[] = Object.keys(
  SUPPORTED_DYNAMIC_ATTRIBUTE_TYPES_DEFS,
) as DynamicAttributeTypes[];

export function isDynamicAttributeDefinition(
  attributeDefinition: AttributeDefinition,
): attributeDefinition is DynamicAttributeDefinition {
  return (
    attributeDefinition.subproperty === undefined &&
    SUPPORTED_DYNAMIC_ATTRIBUTE_TYPES.map(String).includes(attributeDefinition.type)
  );
}

export const getSeriesIcon = (type: DynamicAttributeTypes) =>
  SUPPORTED_DYNAMIC_ATTRIBUTE_TYPES_DEFS[type].icon;
